import { createSelector } from 'reselect'
import { DEFAULT_BENEFITS_VALUE } from 'constants/pickers'
import { hasVisibleBenefitsPicker } from 'domain/packages'
import { CurrentSelection, PackageResource } from 'types/typescript'
import {
  getActivePackage,
  getCurrentSelection
} from './package'
import {
  GetBenefitsAutoSelect,
  GetBenefitsConf,
  GetHasVisibleBenefitsPicker,
  GetSelectedBenefits
} from './pricerBenefits.types'

export const getHasVisibleBenefitsPicker: GetHasVisibleBenefitsPicker = createSelector(
  getActivePackage,
  hasVisibleBenefitsPicker
)

export const getBenefitsConf: GetBenefitsConf = createSelector(
  getActivePackage,
  (activePackage: PackageResource) => activePackage.ecomm?.benefits
)

export const getSelectedBenefits: GetSelectedBenefits = createSelector(
  getCurrentSelection,
  (currentSelection: CurrentSelection) => {
    if (!currentSelection || !currentSelection.benefits) { return null }

    return currentSelection.benefits
  }
)

export const getBenefitsAutoSelect: GetBenefitsAutoSelect = createSelector(
  getHasVisibleBenefitsPicker,
  getSelectedBenefits,
  (hasVisibleBenefitsPicker, selectedBenefits) => (
    hasVisibleBenefitsPicker && !selectedBenefits
      ? DEFAULT_BENEFITS_VALUE
      : null
  )
)
